import { generateClient } from "aws-amplify/api";
import { configureAmplify } from "../../configs/amplify";

// Ensure Amplify is configured (configuration happens in amplify.ts on module load)
configureAmplify();

// Create AppSync GraphQL client
export const appsyncClient = generateClient();

// Helper function to get AppSync client instance
export const getAppSyncClient = () => appsyncClient;
